import React from "react";
import PropTypes from "prop-types";
import { VstInput } from "vstui";
import Isvg from "../../../vendor/react-inlinesvg";

class TreeItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listContainerHeight: 0
    };

    this.listcontRef = React.createRef();
    this.checkboxRef = React.createRef();

    this._clickListItem = this._clickListItem.bind(this);
    this._arrowSlideItem = this._arrowSlideItem.bind(this);
    this._updateTreeItemHeight = this._updateTreeItemHeight.bind(this);
    this._onCheck = this._onCheck.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
  }

  componentDidMount() {
    Fraction.Helpers.runAfterRender(() => this._updateTreeItemHeight());
  }

  componentDidUpdate() {
    this._updateTreeItemHeight();
    if (this.checkboxRef.current) {
      this.checkboxRef.current.indeterminate =
        this.props.collectionstree.checkedStatus === 1;
    }
  }

  _clickListItem(e) {
    this.props.clickListItem(e, this.props.collectionstree);
  }

  _arrowSlideItem(e) {
    this.props.arrowSlideItem(e, this.props.collectionstree);
  }

  _updateTreeItemHeight() {
    const listContainerHeight =
      (this.listcontRef.current && this.listcontRef.current.offsetHeight) || 60;
    if (listContainerHeight > 0 && this.state.listContainerHeight === 0) {
      this.setState({ listContainerHeight });
    }
  }

  _onCheck(e) {
    this.props.onCheck(e, this.props.collectionstree);
    this.forceUpdate();
  }

  _onKeyDown(e) {
    if (e.keyCode === 13) {
      this._onCheck(e);
    }
  }

  render() {
    const {
      collectionstree,
      index,
      i,
      checkbox,
      level,
      selectedLoc,
      buildTree
    } = this.props;
    const { listContainerHeight } = this.state;
    const expandable = collectionstree.children.length > 0;
    const currLoc = index + i + "";
    const titleString = collectionstree.titleString || collectionstree.title;
    const arrowText = collectionstree.expanded
      ? i18n.t("collections.show-less")
      : i18n.t("collections.show-more");
    const arrowForPresentation = !collectionstree.callback;
    const ariaExpanded = expandable
      ? collectionstree.expanded
        ? true
        : false
      : undefined;
    const ariaHidden =
      arrowForPresentation || !(expandable && listContainerHeight > 0);
    const tabIndex =
      (!arrowForPresentation || expandable) && listContainerHeight > 0
        ? "0"
        : "-1";
    const roleAttribute =
      arrowForPresentation && !expandable && listContainerHeight > 0
        ? { role: "presentation" }
        : {};
    return (
      <li
        className={
          checkbox && collectionstree.checkedStatus ? "checked" : "not-checked"
        }
      >
        <div
          data-locator={currLoc}
          ref={this.listcontRef}
          style={{ paddingLeft: 20 * level }}
          className={
            (collectionstree.children ? "first-item" : "") +
            (selectedLoc === currLoc ? " slider-selected" : "")
          }
        >
          <button
            name="slider-hide-show"
            aria-expanded={arrowForPresentation ? undefined : ariaExpanded}
            aria-hidden={true}
            onClick={this._arrowSlideItem}
            tabIndex={ariaHidden ? -1 : 0}
            style={{ height: listContainerHeight }}
            role={ariaHidden ? "presentation" : undefined}
            className={
              "noButton " +
              (expandable && listContainerHeight > 0
                ? "arrow "
                : "hidden-arrow ") +
              (collectionstree.expanded ? "expanded" : "")
            }
          >
            <span className="offScreen">{arrowText}</span>
          </button>
          <button
            name="slider-title-text"
            onClick={this._clickListItem}
            aria-expanded={expandable ? ariaExpanded : null}
            {...roleAttribute}
            tabIndex={tabIndex}
            className="noButton"
          >
            <span className="slider-title">{collectionstree.title}</span>
            {!collectionstree.hideNumbers && (
              <span
                className={"slider-total" + (checkbox ? " has-checkbox" : "")}
                role="presentation"
                style={{
                  height: listContainerHeight,
                  lineHeight: listContainerHeight + "px"
                }}
              >
                ({collectionstree.count})
              </span>
            )}
          </button>
          {checkbox && (
            <div
              className="checkbox-box"
              style={{ marginTop: (listContainerHeight - 45) / 2 }}
            >
              <VstInput
                ref={this.checkboxRef}
                id={"highlighter-checkbox-" + titleString + "_" + currLoc}
                name={"highlighter-checkbox-" + titleString + "_" + currLoc}
                type="checkbox"
                className="highlighter-checkbox"
                data-key={"checkbox_" + titleString + "_" + currLoc}
                checked={collectionstree.isChecked}
                onChange={this._onCheck}
                onKeyDown={this._onKeyDown}
                disabled={collectionstree.count === 0}
                label={i18n.t("base.checkbox-label", { label: titleString })}
                hideLabel
                aria-label={i18n.t("base.checkbox-label", {
                  label: titleString
                })}
              />
            </div>
          )}
        </div>
        {expandable &&
          buildTree(
            collectionstree.children,
            level + 1,
            currLoc + ".",
            collectionstree.expanded
          )}
      </li>
    );
  }
}

TreeItem.propTypes = {
  i: PropTypes.number,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  level: PropTypes.number,
  selectedLoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCheck: PropTypes.func,
  arrowSlideItem: PropTypes.func,
  clickListItem: PropTypes.func,
  collectionstree: PropTypes.shape({
    children: PropTypes.array,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    titleString: PropTypes.string,
    checkedStatus: PropTypes.number,
    count: PropTypes.number,
    isChecked: PropTypes.bool,
    expanded: PropTypes.bool
  })
};

TreeItem.defaultProps = {
  selectedLoc: "",
  i: 0,
  index: 0,
  level: 1,
  collectionstree: {}
};

module.exports = TreeItem;
